
import common_fr from "./fr/common.json"
import user_fr from "./fr/user.json"
import bike_fr from "./fr/bike.json"
import form_fr from "./fr/form.json"
import contact_fr from "./fr/contact.json"
import auth_fr from "./fr/auth.json"
import seo_fr from "./fr/seo.json"
import test_fr from "./fr/test.json"

// **********************************
// *********** Bicycode *******************
// **********************************
import bicycode_contact_fr from "operators/bicycode/translations/fr/contact.json"
import bicycode_auth_fr from "operators/bicycode/translations/fr/auth.json"
import bicycode_bike_fr from "operators/bicycode/translations/fr/bike.json"
import bicycode_faq_fr from "operators/bicycode/translations/fr/faq.json"

import common_en from "operators/bicycode/translations/en/common.json"


// **********************************
// *********** Decathlon *******************
// **********************************
import decathlon_contact_fr from "operators/decathlon/translations/fr/contact.json"
import decathlon_auth_fr from "operators/decathlon/translations/fr/auth.json"
import decathlon_bike_fr from "operators/decathlon/translations/fr/bike.json"
import decathlon_faq_fr from "operators/decathlon/translations/fr/faq.json"

// **********************************
// *********** Moustache *******************
// **********************************
import moustache_bike_fr from "operators/moustache/translations/fr/bike.json"
import moustache_seo_fr from "operators/moustache/translations/fr/seo.json"

// **********************************
// *********** MFC *******************
// **********************************
import mfc_auth_fr from "operators/mfc/translations/fr/auth.json"
import mfc_faq_fr from "operators/mfc/translations/fr/faq.json"

export const resources = {
	fr: {
		common: common_fr,
		user: user_fr,
		bike: bike_fr,
		form: form_fr,
		contact: contact_fr,
		auth: auth_fr,
		seo: seo_fr,
		test: test_fr,

		contact_bicycode: bicycode_contact_fr,
		auth_bicycode: bicycode_auth_fr,
		bike_bicycode: bicycode_bike_fr,
		faq_bicycode: bicycode_faq_fr,

		contact_decathlon: decathlon_contact_fr,
		auth_decathlon: decathlon_auth_fr,
		bike_decathlon: decathlon_bike_fr,
		faq_decathlon: decathlon_faq_fr,

		bike_moustache: moustache_bike_fr,
		seo_moustache: moustache_seo_fr,

		auth_mfc: mfc_auth_fr,
		faq_mfc: mfc_faq_fr,
	},
	en: {
		translation_bicycode: common_en,
	},
}
